var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('XRPTxContainer',{attrs:{"tx":_vm.tx}},[(_vm.domain)?_c('div',{staticClass:"domain"},[_c('div',{staticClass:"tx_detail_label"},[_vm._v("Domain")]),_c('div',[_vm._v(_vm._s(_vm.domain))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }